module.exports = __webpack_public_path__ + "img/checked.3df9a0f6.svg";